// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cart-dropdown .product-item-row:last-child{display:none}.active-dropdown{margin-right:10px}@media screen and (max-width:520px){.cart-dropdown .product-item-row:first-child{flex-direction:row}.cart-dropdown .item-list .product-item-desc{margin-left:20px}}@media screen and (max-width:1023px){.active-dropdown{margin-right:unset}}", ""]);
// Exports
module.exports = exports;
